<div aria-hidden="true">
    <ng-template cdkPortalOutlet></ng-template>
</div>
<!-- Will receive the alert content from the non-live div, move will happen a short delay after opening -->
<div [attr.aria-live]="_live" [attr.role]="_role" [attr.id]="_liveElementId"></div>
